import { StrictMode } from "react";
import { render } from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Layout from "./components/pages/Layout";
import TermsAndConditions from "./components/pages/TermsAndConditions";
import Prospects from "./components/pages/Prospects";
import NewDevice from "./components/pages/NewDevice";
import NotFound from "./components/pages/NotFound";
import RestorePassword from "./components/pages/RestorePassword";

import "./index.css";

render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            path="terminos-y-condiciones"
            element={<TermsAndConditions />}
          />
          <Route
            path="terminos-y-condiciones-tarjeta-de-regalo"
            element={<TermsAndConditions isGiftCard={true} />}
          />
          <Route path="prospects/:token" element={<Prospects />} />
          <Route path="device/confirm/:token" element={<NewDevice />} />
          <Route
            path="password/reset/:email/:token"
            element={<RestorePassword />}
          />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    <ToastContainer
      hideProgressBar
      position="bottom-center"
      style={{ paddingBottom: "2rem" }}
    />
  </StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
